module.exports = __webpack_public_path__ + "fc9ee71202268e3a0f89dfcdf47dd327.png";